import React from "react";
import numeral from "numeral";
import T from "prop-types";
import { Stat } from "MODULES/shared/components";

const depreciationsSum = (data, country) => {
  const field = `${country ? country.toLowerCase() : "total"}_depreciations`;
  const writeDownField = `${country
    ? country.toLowerCase()
    : "total"}_write_downs`;

  return data.reduce(
    (sum, result) =>
      sum + Number(result[field]) + Number(result[writeDownField]),
    0
  );
};

const label = country => (country ? country.toUpperCase() : "Total");

export function DepreciationsSum({ data, dateLabel, country }) {
  return (
    <Stat
      label={`$ Depreciations ${label(country, dateLabel)}`}
      value={numeral(depreciationsSum(data, country)).format("($0,0)")}
      labelFontSize="44px"
    />
  );
}

DepreciationsSum.propTypes = {
  country: T.string,
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};



// WEBPACK FOOTER //
// ./app/modules/DepreciationsDashboard/Components/Stats.jsx